import { createAsyncThunk } from "@reduxjs/toolkit";

import { permissionsType, transformedPermissionsType } from "./types";
import { getPermissionsList } from "../../helpers/backend_helper";

export const getPermissionsThunk = createAsyncThunk<
  {
    response: permissionsType;
    transformedPermissions: transformedPermissionsType;
  },
  number,
  { rejectValue: Error }
>("permissions/getPermissions", async (id, { rejectWithValue }) => {
  try {
    const response: permissionsType = await getPermissionsList(id);

    const transformedPermissions = response?.windows?.reduce(
      (obj, permission) => ({
        ...obj,
        [permission.name]: {
          ...permission,
          filters: permission?.filters?.reduce(
            (acc, filter) => ({ ...acc, [filter.name]: filter }),
            {}
          ),
          elements: permission?.elements?.reduce(
            (acc, element) => ({ ...acc, [element.name]: element }),
            {}
          ),
          columns: permission?.columns?.reduce(
            (acc, column) => ({ ...acc, [column.name]: column }),
            {}
          ),
          tabs:
            permission.tabs === null
              ? null
              : permission?.tabs?.reduce(
                  (acc, tab) => ({ ...acc, [tab.name]: tab }),
                  {}
                ),
        },
      }),
      {}
    ) as transformedPermissionsType;

    return { response, transformedPermissions };
  } catch (error) {
    return rejectWithValue(error as Error);
  }
});
